import {
    serverSideIdToName,
    serverSideIdToSlug,
    serverSideSessionToID,
    serverSideSlugToID,
    serverSideUsers,
    USERSSTATE,
} from '..'
import { Model } from '../../../types/state'
import { EventType } from '../../constants/enums'

if (typeof window !== 'undefined' && window.__MFC_SERVER_SIDE_STATE__) {
    window.__MFC_SERVER_SIDE_STATE__.forEach((state) => {
        const { type, data } = state

        if (type !== EventType.SERVER_SIDE_USER) {
            return
        }

        const { user, isMe } = data as { user: Model; isMe?: boolean }
        const { session, slug, name, id } = user

        if (isMe) {
            serverSideSlugToID['me'] = id
            serverSideIdToSlug[id] = 'me'
        }

        if (slug) {
            serverSideSlugToID[slug] = id
            serverSideIdToSlug[id] = slug
        }

        if (session) {
            serverSideSessionToID[session] = id
        }

        if (name) {
            serverSideIdToName[id] = name
        }

        serverSideUsers[id] = { ...user }
    })
}

// should these be here or in the state.users??
export const sessionToID = serverSideSessionToID
export const slugToID = serverSideSlugToID
export const idToSlug = serverSideIdToSlug
export const idToName = serverSideIdToName

if (typeof window !== 'undefined') {
    window.__MFC_APP_USERS__ = {
        users: USERSSTATE.users,
        sessionToID,
        idToName,
        idToSlug,
        slugToID,
    }
}
